// Map of sectionId -> Splide instance
const cfpSplides = {};

function mountCfpSplide(el) {
  const sectionId = el.id.replace('cfp-splide-', '');

  // Destroy existing instance if re-mounting
  if (cfpSplides[sectionId]) {
    try { cfpSplides[sectionId].destroy(); } catch (e) {}
    delete cfpSplides[sectionId];
  }

  const splide = new Splide(el, {
    type: 'loop',
    perPage: 3,
    gap: '34px',
    focus: 'center',
    padding: 0,
    pagination: true,
    arrows: true,
    trimSpace: true,
    updateOnMove: true,

    autoplay: true,
    interval: 2500,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: false,

    speed: 500,
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)',

    drag: true,
    wheel: false,
    releaseWheel: true,

    breakpoints: {
      1024: {
        perPage: 2,
        gap: '34px',
        padding: 0,
        trimSpace: true,
        interval: 3000,
      },
      768: {
        perPage: 1,
        gap: '20px',
        padding: 0,
        trimSpace: true,
        interval: 3500,
      },
    },
  });

  splide.mount();
  cfpSplides[sectionId] = splide;

  cfpInitAutoScrollControls(splide, el);
  cfpInitIntersectionObserver(splide, el);

  if(window.FeaturedPackedLazy) {
    window.FeaturedPackedLazy.observe(el);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (typeof Splide === 'undefined') return;

  document.querySelectorAll('[id^="cfp-splide-"]').forEach(mountCfpSplide);

  // Subscribe to Dawn's variantChange pubsub event
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, handleCfpVariantChange);
  }
});

function handleCfpVariantChange(event) {
  const variant = event.data?.variant;
  if (!variant) return;

  document.querySelectorAll('[id^="cfp-section-"]').forEach(function (container) {
    const sectionId = container.dataset.sectionId;
    const productUrl = container.dataset.productUrl;
    if (!sectionId || !productUrl) return;

    fetch(`${productUrl}?section_id=${sectionId}&variant=${variant.id}`)
      .then(res => res.text())
      .then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const newList = parsed.querySelector('.splide__list');
        const currentList = container.querySelector('.splide__list');

        if (!newList || !currentList) {
          container.style.display = newList ? '' : 'none';
          return;
        }

        container.style.display = '';
        currentList.innerHTML = newList.innerHTML;

        const splideEl = container.querySelector('[id^="cfp-splide-"]');
        if (splideEl && typeof Splide !== 'undefined') {
          mountCfpSplide(splideEl);

          if (window.FeaturedPackedLazy) {
            window.FeaturedPackedLazy.observe(splideEl);
          }
        }
      })
      .catch(err => console.error('[coffee-feature-packed] variant fetch failed:', err));
  });
}

function cfpInitAutoScrollControls(splide, sliderElement) {
  if (!sliderElement) return;

  let isUserInteracting = false;
  let interactionTimeout;

  function pauseAutoScroll() {
    if (!isUserInteracting) {
      isUserInteracting = true;
      splide.Components.Autoplay.pause();
    }
    clearTimeout(interactionTimeout);
    interactionTimeout = setTimeout(() => {
      isUserInteracting = false;
      splide.Components.Autoplay.play();
    }, 8000);
  }

  sliderElement.addEventListener('mouseenter', () => splide.Components.Autoplay.pause());
  sliderElement.addEventListener('mouseleave', () => {
    if (!isUserInteracting) splide.Components.Autoplay.play();
  });
  sliderElement.addEventListener('touchstart', pauseAutoScroll);
  sliderElement.addEventListener('mousedown', pauseAutoScroll);

  sliderElement.querySelectorAll('.splide__arrow').forEach(arrow => {
    arrow.addEventListener('click', pauseAutoScroll);
  });
  sliderElement.querySelectorAll('.splide__pagination__page').forEach(dot => {
    dot.addEventListener('click', pauseAutoScroll);
  });
  sliderElement.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === ' ') {
      pauseAutoScroll();
    }
  });
}

function cfpInitIntersectionObserver(splide, sliderElement) {
  if (!('IntersectionObserver' in window) || !sliderElement) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        splide.Components.Autoplay.play();
      } else {
        splide.Components.Autoplay.pause();
      }
    });
  }, { threshold: 0.3, rootMargin: '50px' });

  observer.observe(sliderElement);
}
